'use client';

import React, { useState  ,useEffect} from 'react';
import { login } from '../../api';
import { toast } from 'react-hot-toast';
import { useNavigate } from 'react-router-dom';

export default function OtpLogin() {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const navigate = useNavigate();

  useEffect(()=>{
    if(window.localStorage.getItem('authToken')){
      navigate('/');
    }
  },[])

  const handleSubmit = async (e) =>{
    e.preventDefault();
    
    try{

      if(!email){
        toast.error("Please fill all the fields");
        return;
      }
      // const darshanEmailRegex = /@darshan\.ac\.in$/;
  
      // if (!darshanEmailRegex.test(email)) {
      //   console.log(email);
      //   toast.error("Please enter a valid Darshan email address");
      //   return;
      // }
        if(!password){
          toast.error("Please fill all the fields");
          return;
        }
        if(password.length < 6){
          toast.error("Password must be atleast 6 characters long");
          return;
        }
        const response = await login({email:email+'@darshan.ac.in', password});
        if(response){
          toast.success("Login Successful");
          window.localStorage.setItem('authToken', response.token);
        window.localStorage.setItem('student', JSON.stringify(response.student));
          navigate('/');
        }
    }catch(err){
      if(err.code === "resource_not_found") toast.error("User not found please register first");
      if(err.message === "invalid password") toast.error("Invalid Password Or Email");
      console.log(err)
    }
  }

  return (
    <div className="min-h-[72vh] flex items-center justify-center p-4">
      <div className="w-full max-w-md">
        {/* Header */}
        <h1 className="text-center mb-8">
          <span className="text-4xl md:text-5xl font-bold bg-gradient-to-b from-[#190003] to-red-500 bg-clip-text text-transparent">
            Welcome Back
          </span>
          <div className="text-red-400 text-lg mt-2">Login to continue</div>
        </h1>

        {/* Email Form */}
          <form onSubmit={handleSubmit} className="space-y-4">
            <div className="bg-gradient-to-b from-[#190003] to-red-500 p-6 rounded-lg shadow-xl">
              <div className="space-y-4">
                <div>
                  <label htmlFor="email" className="block text-white text-sm font-medium mb-2">
                    Enrollment Number
                  </label>
                  <input
                        type="number"
                        id="email"
                        value={email}
                        onChange={(e) => {
                          const value = e.target.value;
                          if (/^\d+$/.test(value) || value === "") { // Allow only positive numbers or empty
                            setEmail(value);
                          }
                        }}
                        className="w-full px-4 py-2 rounded-md bg-white/10 border border-white/20 text-white placeholder-white/50 focus:outline-none focus:ring-2 focus:ring-red-500"
                        placeholder="Enter your enrollment number"
                        required
                      />
                  
                      <div className='mt-4'>
                      <label htmlFor="email" className="block text-white text-sm font-medium mb-2">
                        Password
                      </label>
                      <input 
                        type='password'
                        id='password'
                        value={password}
                        onChange={(e) => setPassword(e.target.value)}
                        placeholder="Enter your password"
                        className="w-full px-4 py-2 rounded-md bg-white/10 border border-white/20 text-white placeholder-white/50 focus:outline-none focus:ring-2 focus:ring-red-500"
                      />
                      </div>

                </div>
                    <div className="text-left text-white">
                  <p className='text-white cursor-pointer' onClick={()=>{navigate('/forget-password')}}>Forget password?</p>
                </div>
                <button
                  type="submit"
                  className="w-full bg-white text-red-500 py-2 px-4 rounded-md hover:bg-red-50 transition-colors duration-300 font-medium"
                >
                  Submit
                </button>

                    <div className="text-center text-white">
                  <p>Don't have an account? <a href="/Register" className="text-white font-bold hover:underline">Register</a></p>
                </div>
              </div>
            </div>
          </form>
      </div>
    </div>
  );
}
